import React, { useEffect, useState } from "react";
import GOLoading from "../../common/GOLoading";
import YearlySalesCategory from "../Convert/YearlySales/category";
import YearlySalesTickets from "../Convert/YearlySales/tickets";
import YearlySalesSex from "../Convert/YearlySales/sex";
import YearlySalesAge from "../Convert/YearlySales/age";
import CategoryBarChart from "../Chart/YearlySales/CategoryBar";
import TicketsBarChart from "../Chart/YearlySales/TicketsBar";
import GenderBarChart from "../Chart/YearlySales/genderBar";
import AgeBarChart from "../Chart/YearlySales/AgeBar";
import * as Styled from "../chartAreaStyles";
import { useTranslation } from "react-i18next";

const months = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

const YearlySalesChart = ({
  loading,
  year,
  category,
  tickets,
  sex,
  age
}: any) => {
  const { t } = useTranslation();
  const [categoryData, setCategoryDate] = useState<any>({
    labels: months,
    datasets: [
      {
        label: t("trans.newPurchase"),
        backgroundColor: "#7F7ABD",
        data: []
      },
      {
        label: t("trans.renewalPurchase"),
        backgroundColor: "#DCDAFF",
        data: []
      },
      {
        label: t("trans.refundPurchase"),
        backgroundColor: "#767676",
        data: []
      }
    ]
  });

  useEffect(() => {
    const cData = YearlySalesCategory(category);
    const categoryData = {
      labels: months,
      datasets: [
        {
          label: t("trans.newPurchase"),
          backgroundColor: "#7F7ABD",
          data: cData.newPurchase
        },
        {
          label: t("trans.renewalPurchase"),
          backgroundColor: "#DCDAFF",
          data: cData.rePurchase
        },
        {
          label: t("trans.refundPurchase"),
          backgroundColor: "#767676",
          data: cData.refund
        }
      ]
    };
    setCategoryDate(categoryData);
  }, [category]);

  const [ticketData, setTicketData] = useState<any>({
    labels: months,
    datasets: [
      {
        label: t("common.lesson"),
        backgroundColor: "#D2A9D6",
        data: []
      },
      {
        label: t("common.plate"),
        backgroundColor: "#9395E7",
        data: []
      },
      {
        label: t("ticket.etc"),
        backgroundColor: "#464280",
        data: []
      }
    ]
  });

  useEffect(() => {
    const tData = YearlySalesTickets(tickets);
    const ticketData = {
      labels: months,
      datasets: [
        {
          label: t("common.lesson"),
          backgroundColor: "#D2A9D6",
          data: tData.lesson
        },
        {
          label: t("common.plate"),
          backgroundColor: "#9395E7",
          data: tData.plate
        },
        {
          label: t("ticket.etc"),
          backgroundColor: "#464280",
          data: tData.etc
        }
      ]
    };
    setTicketData(ticketData);
  }, [tickets]);

  const [genderData, setGenderData] = useState<any>({
    labels: months,
    datasets: [
      {
        label: t("common.male"),
        backgroundColor: "#6AA8E2",
        data: []
      },
      {
        label: t("common.female"),
        backgroundColor: "#F5C4DE",
        data: []
      }
    ]
  });

  useEffect(() => {
    const sData = YearlySalesSex(sex);
    const genderData = {
      labels: months,
      datasets: [
        {
          label: t("common.male"),
          backgroundColor: "#6AA8E2",
          data: sData.male
        },
        {
          label: t("common.female"),
          backgroundColor: "#F5C4DE",
          data: sData.female
        }
      ]
    };
    setGenderData(genderData);
  }, [sex]);

  const [ageData, setAgeData] = useState<any>({
    labels: months,
    datasets: [
      {
        label: t("trans.under20"),
        backgroundColor: "#D196EE",
        data: []
      },
      {
        label: t("components.accounting.filter.30s"),
        backgroundColor: "#7465E7",
        data: []
      },
      {
        label: t("components.accounting.filter.40s"),
        backgroundColor: "#2F76BA",
        data: []
      },
      {
        label: t("components.accounting.filter.50s"),
        backgroundColor: "#204D80",
        data: []
      },
      {
        label: t("trans.over60"),
        backgroundColor: "#173562",
        data: []
      }
    ]
  });

  useEffect(() => {
    const aData = YearlySalesAge(age);
    const ageData = {
      labels: months,
      datasets: [
        {
          label: t("trans.under20"),
          backgroundColor: "#D196EE",
          data: aData.amount20s
        },
        {
          label: t("components.accounting.filter.30s"),
          backgroundColor: "#7465E7",
          data: aData.amount30s
        },
        {
          label: t("components.accounting.filter.40s"),
          backgroundColor: "#2F76BA",
          data: aData.amount40s
        },
        {
          label: t("components.accounting.filter.50s"),
          backgroundColor: "#204D80",
          data: aData.amount50s
        },
        {
          label: t("trans.over60"),
          backgroundColor: "#173562",
          data: aData.amount60s
        }
      ]
    };
    setAgeData(ageData);
  }, [age]);

  return (
    <Styled.Container>
      {loading ? (
        <GOLoading />
      ) : category && tickets && sex && age ? (
        <>
          {/*<CategoryBarChart label={`${year}_구매종류별`} data={categoryData} />*/}
          {/*<TicketsBarChart label={`${year}_이용권별`} data={ticketData} />*/}
          {/*<GenderBarChart label={`${year}_성별`} data={genderData} />*/}
          {/*<AgeBarChart label={`${year}_연령별`} data={ageData} />*/}
          <CategoryBarChart
            label={`${year}_${t("trans.purchaseType")}`}
            data={categoryData}
          />
          <TicketsBarChart
            label={`${year}_${t("trans.ticketType")}`}
            data={ticketData}
          />
          <GenderBarChart
            label={`${year}_${t("trans.genderType")}`}
            data={genderData}
          />
          <AgeBarChart
            label={`${year}_${t("trans.ageGroupType")}`}
            data={ageData}
          />
        </>
      ) : (
        // <div>데이터가 부족합니다!</div>
        <div>{t("trans.notEnoughData")}</div>
      )}
    </Styled.Container>
  );
};

export default YearlySalesChart;
